export const orderStatusColumnName = 'orderStatus';
export const orderCodeColumnName = 'code';
export const orderSubTotalColumnName = 'subTotal';
